import React from 'react';

/** Full-screen or inline spinner */
export default function Loader({ fullScreen = false }) {
  return (
    <div
      className={`${
        fullScreen ? 'flex h-screen' : 'py-6'
      } w-full items-center justify-center`}
    >
      <svg
        className="h-8 w-8 animate-spin text-blue-600"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8H4z"
        />
      </svg>
    </div>
  );
}
